/** @jsxImportSource @emotion/react */
import * as React from "react";
import errorImgRed from "../../../assets/icons/failureTriangleRed.svg";
import warningImgGold from "../../../assets/icons/warningTriangleSunsetGold.svg";
import TooltipView from "../../../layout/tooltip/TooltipView";

import { css } from "@emotion/react";
import { ErrorImage, ErrorSlot, validationStyles } from "./validationStyles";

const doNothing = () => {};

type ValidationIndicatorProps = {
  message?: string;
  severity?: "error" | "warning";
  visible?: boolean;
};

export const ValidationIndicator: React.FC<ValidationIndicatorProps> = ({
  message,
  severity = "error",
  visible = false,
}) => {
  const [showTooltip, setShowTooltip] = React.useState(false);

  const icon = severity === "warning" ? warningImgGold : errorImgRed;

  return (
    <ErrorSlot>
      {visible && (
        <TooltipView
          rootCss={css`
            margin-left: 5px;
          `}
          side="bottom"
          showTooltip={showTooltip}
          tooltipContent={
            <span css={validationStyles.errorMessage}>{message}</span>
          }
          activateOnHover={false}
          onClickInside={() => setShowTooltip(!showTooltip)}
          onClickOutside={doNothing}
          onHoverInside={doNothing}
          onHoverOutside={doNothing}
        >
          <ErrorImage
            src={icon}
            alt="Error Image"
            title={message}
            style={{ opacity: visible ? 1 : 0 }}
          />
        </TooltipView>
      )}
    </ErrorSlot>
  );
};
